import { useRef, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  decrementLastRecommendationsIndex,
  getNextRecommendations,
} from '../util/getNextRecommendations'
import Recommendation from './Recommendation'
import { TRY_THESE_VIRTUAL_BACKGROUND_IDEAS } from './translation/resources'
import './Recommendations.css'

const recommendations = getNextRecommendations()

const Recommendations = () => {
  const { t, i18n } = useTranslation()
  const listRef = useRef(null)
  const [total, setTotal] = useState(4)

  useEffect(() => {
    const checkOverflow = () => {
      const listElement = listRef.current
      const lastItem = listElement.lastElementChild

      if (lastItem) {
        const listBottom = listElement.getBoundingClientRect().bottom
        const lastItemBottom = lastItem.getBoundingClientRect().bottom

        if (lastItemBottom > listBottom) {
          listElement.removeChild(lastItem)
          decrementLastRecommendationsIndex()
          setTotal((prev) => prev - 1)
        }
      }
    }

    checkOverflow()
  }, [i18n.language])

  return (
    <div className="Recommendations">
      <p className="Recommendations__title">
        {t(TRY_THESE_VIRTUAL_BACKGROUND_IDEAS)}
      </p>
      <div
        className="Recommendations__list"
        ref={listRef}
        role="group"
        aria-label="Virtual background"
      >
        {recommendations.map((recommendation, index) => (
          <Recommendation
            key={recommendation}
            recommendation={recommendation}
            index={index}
            total={total}
          />
        ))}
      </div>
    </div>
  )
}

export default Recommendations
